export const CUSTOMER_API_CONFIG = {
    // Use local Next.js API routes which proxy to external API with authentication
    BASE_URL: '/api',
    BASE_ROUTE: '/admin/customers',
    get ENDPOINTS() {
        return {
            LIST: this.BASE_ROUTE,
            CREATE: this.BASE_ROUTE,
            DETAILS: `${this.BASE_ROUTE}/{ref}`,
            UPDATE: `${this.BASE_ROUTE}/{ref}`,
            DELETE: `${this.BASE_ROUTE}/{ref}`,
            SUMMARY: `${this.BASE_ROUTE}/summary`,
            REVEAL: `${this.BASE_ROUTE}/{ref}/reveal`,
        };
    }
} as const;

Object.entries(CUSTOMER_API_CONFIG.ENDPOINTS).forEach(([key, value]) => {
});
/**
 * Dynamically builds the API URL based on endpoint type and params.
 * Always targets the local Next.js proxy (/api/...) which then forwards to Beeceptor.
 */
export function getCustomerApiUrl(type: keyof typeof CUSTOMER_API_CONFIG.ENDPOINTS, params: Record<string, string> = {}): string {
    let base: string = CUSTOMER_API_CONFIG.BASE_URL;
    base = base.replace(/\/+$/, '');

    const endpoints = CUSTOMER_API_CONFIG.ENDPOINTS;
    let endpoint = endpoints[type] as string;
    if (!endpoint.startsWith('/')) endpoint = '/' + endpoint;

    Object.entries(params).forEach(([key, value]) => {
        endpoint = endpoint.replace(`{${key}}`, value);
    });

    return `${base}${endpoint}`;
}

export const CUSTOMER_FIELD_KEYS = {
    email: 'email',
    phone: 'phone',
    name: 'name',
    firstName: 'firstName',
    lastName: 'lastName',
    id: 'id',
    status: 'status',
    authCode: 'authCode',
};
